<template>
  <div class="template-connected" :key="user.id">
    <div id="container">
      <div id="title">
        <h1 v-if="add == false">
          Modification utilisateur : {{ user.lastName }}
          {{ user.firstName }}
        </h1>
        <h1 v-else>Ajout d'un utilisateur</h1>
      </div>
      <div id="content" class="form-horizontal">
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <div class="block-flat">
              <div class="block-content">
                <fieldset>
                  <legend>Droits</legend>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="2" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Rôle :</label>
                      </b-col>
                      <b-col
                        lg="10"
                        md="10"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <b-form-checkbox-group
                          :disabled="readOnly"
                          v-model="user.roles"
                          :options="roles"
                        ></b-form-checkbox-group>
                      </b-col>
                    </b-row>
                  </div>
                  <div
                    class="form-group"
                    v-if="
                      user.roles && user.roles.includes('ROLE_SOUSTRAITANT')
                    "
                  >
                    <b-row>
                      <b-col lg="4" md="4" sm="12" cols="12">
                        <label class="control-label"
                          >Sous-traitant <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col
                        lg="6"
                        md="6"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <div>
                          <ValidationProvider
                            mode="lazy"
                            v-slot="{ errors }"
                            ref="providerSousTraitant"
                            name="sous-traitant"
                          >
                            <autocomplete
                              :class="
                                readOnly ||
                                (!userConnected.roles.includes(
                                  'ROLE_GUICHET'
                                ) &&
                                  !userConnected.roles.includes('ROLE_ADMIN') &&
                                  add == false) ||
                                (add == true &&
                                  userConnected.roles.includes(
                                    'ROLE_SOUSTRAITANT'
                                  ))
                                  ? 'disabled'
                                  : errors.length > 0
                                  ? 'error'
                                  : ''
                              "
                              @selected="setSousTraitant"
                              results-property="data"
                              :request-headers="{ Authorization: token }"
                              :source="
                                urlapi +
                                'perimeter?limit=10&type=soustraitant&q='
                              "
                              resultsValue="id"
                              :disableInput="
                                readOnly ||
                                (!userConnected.roles.includes(
                                  'ROLE_GUICHET'
                                ) &&
                                  !userConnected.roles.includes('ROLE_ADMIN') &&
                                  add == false) ||
                                (add == true &&
                                  userConnected.roles.includes(
                                    'ROLE_SOUSTRAITANT'
                                  ))
                              "
                              resultsDisplay="libelle"
                              placeholder="Recherche..."
                              :initial-value="
                                user.sousTraitantPerimeter != null
                                  ? user.sousTraitantPerimeter.id
                                  : null
                              "
                              :initialDisplay="
                                user.sousTraitantPerimeter != null
                                  ? user.sousTraitantPerimeter.libelle
                                  : null
                              "
                              input-class="form-control"
                            >
                              <template v-slot:noResults>
                                Pas de résultat
                              </template>
                            </autocomplete>
                            <div class="error">{{ errors[0] }}</div>
                          </ValidationProvider>

                          <!-- <b-form-select v-model="userSelected.operatorPerimeterId"  value-field="id" text-field="libelle" :options="perimetersOperator"></b-form-select> -->
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div
                    class="form-group"
                    v-if="user.roles && user.roles.includes('ROLE_USER')"
                  >
                    <b-row>
                      <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                        <label class="control-label"
                          >Opérateur <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col
                        xl="6"
                        lg="6"
                        md="6"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <div>
                          <ValidationProvider
                            mode="lazy"
                            v-slot="{ errors }"
                            ref="providerOperator"
                            name="opérateur"
                          >
                            <autocomplete
                              :class="
                                (readOnly &&
                                  !userConnected.roles.includes(
                                    'ROLE_GUICHET'
                                  ) &&
                                  !userConnected.roles.includes('ROLE_ADMIN') &&
                                  add == false) ||
                                (add == true &&
                                  userConnected.roles.includes('ROLE_USER'))
                                  ? 'disabled'
                                  : errors.length > 0
                                  ? 'error'
                                  : ''
                              "
                              @selected="setOperator"
                              results-property="data"
                              :request-headers="{ Authorization: token }"
                              :source="
                                urlapi + 'perimeter?limit=10&type=operator&q='
                              "
                              resultsValue="id"
                              :disableInput="
                                (readOnly &&
                                  !userConnected.roles.includes(
                                    'ROLE_GUICHET'
                                  ) &&
                                  !userConnected.roles.includes('ROLE_ADMIN') &&
                                  add == false) ||
                                (add == true &&
                                  userConnected.roles.includes('ROLE_USER'))
                              "
                              resultsDisplay="libelle"
                              placeholder="Recherche..."
                              :initial-value="
                                user.operatorPerimeter != null
                                  ? user.operatorPerimeter.libelle
                                  : null
                              "
                              :initialDisplay="
                                user.operatorPerimeter != null
                                  ? user.operatorPerimeter.id
                                  : null
                              "
                              input-class="form-control"
                            >
                              <template v-slot:noResults>
                                Pas de résultat
                              </template>
                            </autocomplete>
                            <div class="error">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- <b-form-select v-model="userSelected.operatorPerimeterId"  value-field="id" text-field="libelle" :options="perimetersOperator"></b-form-select> -->
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div
                    class="form-group"
                    v-if="user.roles && user.roles.includes('ROLE_GUICHET')"
                  >
                    <b-row>
                      <b-col
                        xl="3"
                        lg="4"
                        md="4"
                        sm="12"
                        cols="12"
                        class="no-padding"
                      >
                        <label class="control-label"
                          >Périmètre du guichet :</label
                        >
                      </b-col>
                      <b-col
                        xl="9"
                        lg="8"
                        md="8"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <div>
                          <autocomplete
                            @clear="setTicketOffice"
                            @selected="setTicketOffice"
                            results-property="data"
                            :request-headers="{ Authorization: token }"
                            :source="
                              urlapi +
                              'perimeter?limit=10&type=epci,department&q='
                            "
                            resultsValue="id"
                            resultsDisplay="libelle"
                            input-class="form-control"
                            placeholder="Recherche..."
                            :initial-value="
                              user.ticketOfficePerimeter != null
                                ? user.ticketOfficePerimeter.id
                                : null
                            "
                            :initialDisplay="
                              user.ticketOfficePerimeter != null
                                ? user.ticketOfficePerimeter.libelle
                                : null
                            "
                          >
                            <template v-slot:noResults>
                              Pas de résultat
                            </template>
                          </autocomplete>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div
                    class="form-group"
                    v-if="
                      user.roles && user.roles.includes('ROLE_GESTIONNAIRE')
                    "
                  >
                    <b-row>
                      <b-col
                        xl="3"
                        lg="4"
                        md="4"
                        sm="12"
                        cols="12"
                        class="no-padding"
                      >
                        <label class="control-label"
                          >Périmètre du Gestionnaire :</label
                        >
                      </b-col>
                      <b-col
                        xl="9"
                        lg="8"
                        md="8"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <div>
                          <b-form-radio-group
                            v-model="user.managerPerimeter.type"
                            :options="perimetres"
                            :disabled="
                              readOnly ||
                              (!userConnected.roles.includes('ROLE_GUICHET') &&
                                !userConnected.roles.includes('ROLE_ADMIN') &&
                                add == false) ||
                              (add == true &&
                                userConnected.roles.includes(
                                  'ROLE_GESTIONNAIRE'
                                ) &&
                                !userConnected.roles.includes('ROLE_GUICHET'))
                            "
                            class="mb-3"
                            value-field="value"
                            text-field="text"
                          ></b-form-radio-group>
                          <!--                                                    <ValidationProvider mode="lazy" v-slot="{ errors }" rules="required" name="operateur">-->
                          <autocomplete
                            :disableInput="
                              user.managerPerimeter.type == null ||
                              readOnly ||
                              (!userConnected.roles.includes('ROLE_GUICHET') &&
                                !userConnected.roles.includes('ROLE_ADMIN') &&
                                add == false) ||
                              (add == true &&
                                userConnected.roles.includes(
                                  'ROLE_GESTIONNAIRE'
                                ) &&
                                !userConnected.roles.includes('ROLE_GUICHET'))
                            "
                            :class="
                              user.managerPerimeter.type == null ||
                              readOnly ||
                              (!userConnected.roles.includes('ROLE_GUICHET') &&
                                !userConnected.roles.includes('ROLE_ADMIN') &&
                                add == false) ||
                              (add == true &&
                                userConnected.roles.includes(
                                  'ROLE_GESTIONNAIRE'
                                ) &&
                                !userConnected.roles.includes('ROLE_GUICHET'))
                                ? 'disabled'
                                : ''
                            "
                            @selected="setManager"
                            @clear="setManager"
                            results-property="data"
                            :request-headers="{ Authorization: token }"
                            :source="
                              urlapi +
                              'perimeter?limit=10&type=' +
                              (user.managerPerimeter != null
                                ? user.managerPerimeter.type != null
                                  ? user.managerPerimeter.type
                                  : ''
                                : '') +
                              '&q='
                            "
                            resultsValue="id"
                            placeholder="Recherche..."
                            resultsDisplay="libelle"
                            input-class="form-control"
                            :initial-value="
                              user.managerPerimeter != null
                                ? user.managerPerimeter.id
                                : null
                            "
                            :initialDisplay="
                              user.managerPerimeter != null
                                ? user.managerPerimeter.libelle
                                : null
                            "
                          >
                            <template v-slot:noResults>
                              Pas de résultat
                            </template>
                          </autocomplete>
                          <!--                                                    </ValidationProvider>-->
                          <!-- <b-form-select v-model="userSelected.managerPerimeterId"  value-field="id" text-field="libelle" :options="perimetersManager"></b-form-select> -->
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div
                    class="form-group"
                    v-if="
                      userConnected &&
                      userConnected.roles.includes('ROLE_ADMIN')
                    "
                  >
                    <b-row>
                      <b-col lg="4" md="4" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Possibilité de supprimer d'autres utilisateurs</label
                        >
                      </b-col>
                      <b-col
                        lg="8"
                        md="8"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <b-form-checkbox
                          v-model="user.allowDelete"
                        ></b-form-checkbox>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="form-group">
                    <b-row>
                      <b-col
                        xl="3"
                        lg="4"
                        md="4"
                        sm="12"
                        cols="12"
                        class="no-padding"
                      >
                        <label class="control-label">Pôle :</label>
                      </b-col>
                      <b-col
                        xl="9"
                        lg="8"
                        md="8"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <div>
                          <autocomplete
                            @clear="setPole"
                            @selected="setPole"
                            results-property="data"
                            :request-headers="{ Authorization: token }"
                            :source="urlapi + 'perimeter?limit=10&type=pole&q='"
                            resultsValue="id"
                            placeholder="Recherche..."
                            resultsDisplay="libelle"
                            input-class="form-control"
                            :initial-value="
                              user.pole != null ? user.pole.id : null
                            "
                            :initialDisplay="
                              user.pole != null ? user.pole.libelle : null
                            "
                          >
                            <template v-slot:noResults>
                              Pas de résultat
                            </template>
                          </autocomplete>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Utilisateur</legend>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Avatar :</label>
                      </b-col>
                      <b-col
                        lg="2"
                        md="9"
                        sm="12"
                        cols="12"
                        class="avatar-profil"
                      >
                        <div class="container-avatar">
                          <div class="profil">
                            <b-img
                              v-if="user.picture == null"
                              img
                              src="../img/avatar-client.png"
                              alt="user-img"
                            />
                            <b-img-lazy
                              v-else
                              img
                              :key="user.picture"
                              :src="user.picture"
                              class="img-circle"
                              alt="user-img"
                            />
                            <label class="change" v-if="!readOnly">
                              <b-form-file
                                @input="upload(user.id)"
                                style="display: none"
                                v-model="picture"
                                accept="image/*"
                                hidden
                              ></b-form-file>
                              <font-awesome-icon
                                icon="camera"
                              ></font-awesome-icon>
                            </label>
                          </div>
                        </div>
                      </b-col>

                      <b-col lg="1" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Statut <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col
                        lg="7"
                        md="9"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required"
                          name="nature"
                        >
                          <b-form-radio-group
                            :state="errors[0] ? false : null"
                            :disabled="
                              readOnly ||
                              user.operatorPerimeterId != null ||
                              user.sousTraitantPerimeterId != null
                            "
                            v-model="user.nature"
                            :options="natures"
                          ></b-form-radio-group>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                  </div>
                  <!--<div id="par">-->
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Titre <span class="red">*</span>, nom
                          <span class="red">*</span>, prénom
                          <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col
                        lg="10"
                        md="9"
                        sm="12"
                        cols="12"
                        class="no-padding"
                      >
                        <b-row class="no-margin">
                          <b-col lg="2" md="3" sm="3" cols="12">
                            <ValidationProvider
                              mode="lazy"
                              v-slot="{ errors }"
                              rules="required"
                              name="titre"
                            >
                              <b-form-select
                                :disabled="readOnly"
                                :state="errors[0] ? false : null"
                                v-model="user.title"
                                :options="titles"
                              ></b-form-select>
                              <div class="error">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="5" md="9" sm="9" cols="12">
                            <ValidationProvider
                              mode="lazy"
                              v-slot="{ errors }"
                              rules="required"
                              name="nom"
                            >
                              <b-form-input
                                :disabled="readOnly"
                                :state="errors[0] ? false : null"
                                v-model="user.lastName"
                                placeholder="Merci de renseigner le nom"
                              ></b-form-input>
                              <div class="error">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="5" md="12" sm="12" cols="12">
                            <ValidationProvider
                              mode="lazy"
                              v-slot="{ errors }"
                              rules="required"
                              name="prénom"
                            >
                              <b-form-input
                                :disabled="readOnly"
                                :state="errors[0] ? false : null"
                                v-model="user.firstName"
                                placeholder="Merci de renseigner le prénom"
                              ></b-form-input>
                              <div class="error">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Fonction <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col
                        lg="10"
                        md="9"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required"
                          name="fonction"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            :state="errors[0] ? false : null"
                            v-model="user.quality"
                            placeholder="Merci de renseigner votre fonction"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label clearfix"
                          >Adresse email <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col lg="10" md="9" sm="12" cols="12">
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required|email"
                          name="email"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            :state="errors[0] ? false : null"
                            v-model="user.email"
                            placeholder="Email"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="4" md="4" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Désactiver la réception des mails de notifications :
                        </label>
                      </b-col>
                      <b-col
                        lg="8"
                        md="8"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <b-form-checkbox
                          v-model="user.disableMails"
                        ></b-form-checkbox>
                      </b-col>
                    </b-row>
                  </div>
                  <!--</div>-->
                  <div id="pro" v-show="user.nature != 'Particulier'">
                    <div class="form-group">
                      <b-row>
                        <b-col
                          lg="2"
                          md="3"
                          sm="12"
                          cols="12"
                          class="no-padding"
                        >
                          <label class="control-label"
                            >Dénomination <span class="red">*</span> :</label
                          >
                        </b-col>
                        <b-col lg="4" md="9" sm="12" cols="12">
                          <ValidationProvider
                            mode="lazy"
                            v-slot="{ errors }"
                            rules="required"
                            name="dénomination"
                          >
                            <b-form-input
                              :state="errors[0] ? false : null"
                              :disabled="
                                readOnly ||
                                user.operatorPerimeterId != null ||
                                user.sousTraitantPerimeterId != null
                              "
                              v-model="user.corporationName"
                              placeholder="Merci de renseigner la dénomination"
                            ></b-form-input>
                            <div class="error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </b-col>

                        <b-col
                          lg="2"
                          md="3"
                          sm="12"
                          cols="12"
                          class="no-padding"
                        >
                          <label class="control-label">N° SIRET :</label>
                        </b-col>
                        <b-col lg="4" md="4" sm="12" cols="12">
                          <b-form-input
                            :disabled="
                              readOnly ||
                              user.operatorPerimeterId != null ||
                              user.sousTraitantPerimeterId != null
                            "
                            v-model="user.corporationSiret"
                            placeholder="Merci de renseigner le n° SIRET"
                          ></b-form-input>
                        </b-col>
                        <b-col
                          lg="2"
                          md="3"
                          sm="12"
                          cols="12"
                          class="marginTop no-padding"
                        >
                          <label class="control-label"
                            >Représenté par <span class="red">*</span> :</label
                          >
                        </b-col>

                        <b-col
                          lg="10"
                          md="9"
                          sm="12"
                          cols="12"
                          class="no-padding"
                        >
                          <b-row>
                            <b-col lg="2" md="3" sm="3" cols="12">
                              <ValidationProvider
                                mode="lazy"
                                v-slot="{ errors }"
                                rules="required"
                                name="titre du représentant"
                              >
                                <b-form-select
                                  :disabled="readOnly"
                                  :state="errors[0] ? false : null"
                                  v-model="user.corporationAgentTitle"
                                  :options="titles"
                                ></b-form-select>
                                <div class="error">{{ errors[0] }}</div>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="10" md="9" sm="9" cols="12">
                              <ValidationProvider
                                mode="lazy"
                                v-slot="{ errors }"
                                rules="required"
                                name="Nom et Prénom du représentant"
                              >
                                <b-form-input
                                  :disabled="readOnly"
                                  :state="errors[0] ? false : null"
                                  v-model="user.corporationAgent"
                                  placeholder="Nom et Prénom du représentant"
                                ></b-form-input>
                                <div class="error">{{ errors[0] }}</div>
                              </ValidationProvider>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Coordonnées</legend>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Numéro :</label>
                      </b-col>
                      <b-col lg="2" md="9" sm="12" cols="12">
                        <b-form-input
                          :disabled="readOnly"
                          v-model="user.addressNum"
                          placeholder="Numéro"
                        ></b-form-input>
                      </b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Extension :</label>
                      </b-col>
                      <b-col lg="2" md="9" sm="12" cols="12">
                        <b-form-input
                          :disabled="readOnly"
                          v-model="user.addressExt"
                          placeholder="Extension"
                        ></b-form-input>
                      </b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Type de voie <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col lg="2" md="9" sm="12" cols="12">
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required"
                          name="type de voie"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            :state="errors[0] ? false : null"
                            v-model="user.addressType"
                            placeholder="Type"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                      <!--<b-col lg="12" md="12" sm="12" cols="12" class="nopadding"></b-col>-->
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Nom de voie <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col lg="10" md="9" sm="12" cols="12">
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required"
                          name="nom de voie"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            :state="errors[0] ? false : null"
                            v-model="user.addressName"
                            placeholder="Nom de la voie"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                      <!--<b-col lg="12" md="12" sm="12" cols="12" class="nopadding"></b-col>-->
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Localité <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col lg="6" md="9" sm="12" cols="12">
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required"
                          name="ville"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            v-model="user.addressCity"
                            :state="errors[0] ? false : null"
                            placeholder="Ville"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Code postal <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col lg="2" md="9" sm="12" cols="12">
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required"
                          name="code postal"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            :state="errors[0] ? false : null"
                            v-model="user.addressPostalCode"
                            placeholder="Code postal"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label clearfix"
                          >Téléphone <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col lg="3" md="9" sm="12" cols="12">
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required"
                          name="téléphone"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            :state="errors[0] ? false : null"
                            v-model="user.phone"
                            placeholder="Numéros de téléphone"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                      <b-col lg="4" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Indicatif pour le pays étranger :</label
                        >
                      </b-col>
                      <b-col lg="3" md="9" sm="12" cols="12">
                        <b-form-input
                          :disabled="readOnly"
                          v-model="user.phoneIndicative"
                          placeholder="Indicatif pays étranger"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </div>
                </fieldset>
              </div>
            </div>
            <b-row>
              <b-col lg="12" md="12" sm="12" cols="12" class="text-center">
                <b-button
                  @click="cancel()"
                  variant="danger"
                  class="btn-line btn-auto marginBottom-15"
                >
                  <font-awesome-icon icon="times"></font-awesome-icon>
                  Annuler
                </b-button>
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-auto marginBottom-15"
                  v-if="!readOnly"
                >
                  <font-awesome-icon icon="check"></font-awesome-icon>
                  Valider
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import Vue from "vue";
import router from "../router";

export default {
  name: "Account",

  async beforeMount() {
    //edition d'un profil
    let rep = "";
    if (
      this.$route.params.id &&
      this.$route.params.id != this.userConnected.id
    ) {
      let decrypted = this.$aes.decrypt(this.$route.params.id);
      rep = await this.getUser(decrypted);
      if (
        !this.userConnected.roles.includes("ROLE_ADMIN") &&
        !this.userConnected.roles.includes("ROLE_GUICHET")
      ) {
        this.readOnly = true;
      } else {
        this.readOnly = false;
      }
    } else {
      //ajout
      if (this.$route.name == "NewUser") {
        rep = await this.initUser();
        if (this.userConnected.roles.includes("ROLE_SOUSTRAITANT")) {
          this.user.sousTraitantPerimeter =
            this.userConnected.sousTraitantPerimeter;
          this.user.sousTraitantPerimeterId =
            this.userConnected.sousTraitantPerimeter.id;
          this.user.nature = "Entreprise";
          this.user.corporationName =
            this.userConnected.sousTraitantPerimeter.libelle;
          this.user.corporationSiret =
            this.userConnected.sousTraitantPerimeter.code;
        }
        if (this.userConnected.roles.includes("ROLE_GESTIONNAIRE")) {
          this.user.managerPerimeter = this.userConnected.managerPerimeter;
          this.user.managerPerimeterId = this.userConnected.managerPerimeter.id;
        }
        if (this.userConnected.roles.includes("ROLE_USER")) {
          this.user.operatorPerimeter = this.userConnected.operatorPerimeter;
          this.user.operatorPerimeterId =
            this.userConnected.operatorPerimeter.id;
          this.user.nature = "Entreprise";
          this.user.corporationName =
            this.userConnected.operatorPerimeter.libelle;
          this.user.corporationSiret =
            this.userConnected.operatorPerimeter.code;
        }
        this.add = true;
        this.readOnly = false;
      }
      //edition du profil de l'utilisateur connecté
      else {
        rep = await this.getUserConnected();
        rep = await this.getUser(this.userConnected.id);
        this.add = false;
        this.readOnly = false;
      }
    }
  },
  data: () => ({
    urlapi: window.urlapi,
    publicPath: process.env.BASE_URL,
    picture: null,
    add: false,
    readOnly: false,
  }),
  // titles
  methods: {
    setManager(data) {
      if (data) {
        this.user.managerPerimeterId = data.value;
      } else {
        this.user.managerPerimeterId = null;
      }
    },
    setPole(data) {
      if (data) {
        this.user.poleId = data.value;
      } else {
        this.user.poleId = null;
      }
    },
    setOperator(data) {
      this.user.operatorPerimeterId = data.value;

      this.user.nature = "Entreprise";
      this.user.corporationName = data.selectedObject.libelle;
      this.user.corporationSiret = data.selectedObject.code;
    },
    setSousTraitant(data) {
      this.user.sousTraitantPerimeterId = data.value;
      this.user.nature = "Entreprise";
      this.user.corporationName = data.selectedObject.libelle;
      this.user.corporationSiret = data.selectedObject.code;
    },
    setTicketOffice(data) {
      if (data) {
        this.user.ticketOfficePerimeterId = data.value;
      } else {
        this.user.ticketOfficePerimeterId = null;
      }
    },

    cancel() {
      if (this.$route.params.id) {
        let decrypted = this.$aes.decrypt(this.$route.params.id);
        this.getUser(decrypted);
      } else {
        this.getUser(this.userConnected.id);
      }
      router.push({ name: "Users" });
    },
    save() {
      if (
        this.user.roles.includes("ROLE_USER") ||
        this.user.roles.includes("ROLE_SOUSTRAITANT")
      ) {
        if (
          this.user.operatorPerimeterId == null &&
          this.user.roles.includes("ROLE_USER")
        ) {
          this.$refs.providerOperator.applyResult({
            errors: ["Le champ opérateur est obligatoire"], // array of string errors
            valid: false, // boolean state
            failedRules: {}, // should be empty since this is a manual error.
          });
        }

        if (
          this.user.sousTraitantPerimeterId == null &&
          this.user.roles.includes("ROLE_SOUSTRAITANT")
        ) {
          this.$refs.providerSousTraitant.applyResult({
            errors: ["Le champ sous-traitant est obligatoire"], // array of string errors
            valid: false, // boolean state
            failedRules: {}, // should be empty since this is a manual error.
          });
        }

        if (
          (this.user.operatorPerimeterId == null &&
            this.user.roles.includes("ROLE_USER")) ||
          (this.user.sousTraitantPerimeterId == null &&
            this.user.roles.includes("ROLE_SOUSTRAITANT"))
        )
          return;
      }

      if (this.add == false) {
        this.updateUser(this.user);
      } else {
        this.addUser(this.user);
      }
    },
    upload(id) {
      let formData = new FormData();
      formData.append("file", this.picture);
      formData.append("userId", id);
      Vue.axios
        .post(window.urlapi + "stduser/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.user.picture = response.data.data;
          Vue.prototype.$awn.success(response.data.message.toString());
        });
    },
    ...Vuex.mapActions("Authentification", ["getUserConnected"]),
    ...Vuex.mapActions("User", [
      "getUser",
      "setUser",
      "updateUser",
      "addUser",
      "initUser",
    ]),
  },

  watch: {},
  computed: {
    user: {
      get() {
        return this.userSelected;
      },
      set(value) {
        this.setUser(value);
      },
    },
    perimetres: function () {
      let tab = [];

      if (
        !this.userConnected.roles.includes("ROLE_GUICHET") &&
        !this.userConnected.roles.includes("ROLE_ADMIN") &&
        this.add == false
      ) {
        tab.push({ value: "department", text: "Département", disabled: true });
        tab.push({ value: "epci", text: "EPCI", disabled: true });
        tab.push({ value: "town", text: "Commune", disabled: true });
      } else {
        tab.push({ value: "department", text: "Département" });
        tab.push({ value: "epci", text: "EPCI" });
        tab.push({ value: "town", text: "Commune" });
      }
      return tab;
    },
    roles: function () {
      let tab = [];

      //DROIT PAR RAPPORT à l'utilisateur connecter
      if (
        !this.userConnected.roles.includes("ROLE_GUICHET") &&
        !this.userConnected.roles.includes("ROLE_ADMIN")
      ) {
        tab.push({ value: "ROLE_GUICHET", text: "Guichet", disabled: true });
        if (this.userConnected.roles.includes("ROLE_GESTIONNAIRE")) {
          if (
            this.add == true &&
            !this.user.roles.includes("ROLE_GESTIONNAIRE")
          ) {
            this.user.roles.push("ROLE_GESTIONNAIRE");
          }
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
          });
        }
        if (this.userConnected.roles.includes("ROLE_USER")) {
          if (this.add == true && !this.user.roles.includes("ROLE_USER")) {
            this.user.roles.push("ROLE_USER");
          }
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
            checked: true,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
          });
        }
        if (this.userConnected.roles.includes("ROLE_SOUSTRAITANT")) {
          if (
            this.add == true &&
            !this.user.roles.includes("ROLE_SOUSTRAITANT")
          ) {
            this.user.roles.push("ROLE_SOUSTRAITANT");
          }
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
            checked: true,
          });
        }
      } else {
        //Droit par rapport au objet selectionné
        if (
          this.user &&
          this.user.roles &&
          this.user.roles.includes("ROLE_USER")
        ) {
          tab.push({
            value: "ROLE_GUICHET",
            text: "Guichet",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: false,
            checked: true,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
            checked: false,
          });
        } else if (
          this.user &&
          this.user.roles &&
          this.user.roles.includes("ROLE_SOUSTRAITANT")
        ) {
          tab.push({
            value: "ROLE_GUICHET",
            text: "Guichet",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: false,
            checked: true,
          });
        } else if (
          (this.user.roles && this.user.roles.includes("ROLE_GESTIONNAIRE")) ||
          (this.user.roles && this.user.roles.includes("ROLE_GUICHET"))
        ) {
          tab.push({ value: "ROLE_GUICHET", text: "Guichet", disabled: false });
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: false,
          });

          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
            checked: false,
          });
        } else {
          tab.push({ value: "ROLE_GUICHET", text: "Guichet", disabled: false });
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: false,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: false,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: false,
          });
        }
      }

      return tab;
    },

    ...Vuex.mapGetters("Dossiers", ["dossiers"]),
    ...Vuex.mapGetters("Authentification", ["userConnected", "token"]),
    ...Vuex.mapGetters("User", ["userSelected", "natures", "titles"]),
  },
};
</script>

<style scoped></style>
